import React from 'react';
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
  CImage,
} from '@coreui/react-pro';
import PrivateSidebarNav from './PrivateSidebarNav';
import logo from '../../../assets/images/sidebar-logo.png';
import icon from '../../../assets/images/premier-plus-icon.png';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import navigation from './PrivateNavigation';
import {
  toggleSidebarUnfoldable,
  setSidebarHidden,
} from '../../../shared/actions';
import { 
  useDispatch,
  useSelector,
} from 'react-redux';

const PrivateSidebar = () => {
  
  const dispatch = useDispatch();

  const {
    sidebarUnfoldable,
    sidebarVisible,
  } = useSelector((state) => state.userSettings);

  React.useEffect(() => {

  }, []);
  
  return (
    <CSidebar 
      position='fixed'
      unfoldable={sidebarUnfoldable}
      visible={sidebarVisible}
      onVisibleChange={(visible) => {
        if (visible === false) {
          dispatch(setSidebarHidden());
        }
      }}>
      <CSidebarBrand className='d-none d-md-flex' style={{backgroundColor: 'white',}}>
        <CImage className='sidebar-brand-full' src={logo} height={35} />
        <CImage className='sidebar-brand-narrow' src={icon} height={35} />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <PrivateSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className='d-none d-lg-flex'
        onClick={() => dispatch(toggleSidebarUnfoldable())} />
    </CSidebar>
  );
}

export default React.memo(PrivateSidebar);
